import { css } from 'styled-components';

export const alreadyPrintedStyles = css``;
